<template>

  <v-container fill-height
               fluid
               grid-list-xl>
    <v-layout justify-center
              wrap>
      <v-flex xs12 md10>
        <material-card :color="getTitleColorStore"
                       :title="$t('menu_exam_unregister')"
                       :text="$t('exam_unregister.subtitle')">
          <ProgressBar :loading="loading" color="deep-purple accent-4" />
          <template>
            <v-container grid-list-md>
              <v-layout row wrap>

                <v-flex xs-12 d-flex>
                  <v-data-table :headers="headers1()"
                                :items="tableData"
                                prev-icon="mdi-menu-left"
                                next-icon="mdi-menu-right"
                                class="v-icon-fix custom-table-header"
                                :pagination.sync="pagination">

                    <template slot="headerCell" slot-scope="{ header }">
                      <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
                    </template>

                    <template slot="items" slot-scope="{ index, item }">
                      <ExamTr :item="item" :index="index" @examRowClick="passEvent"></ExamTr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
          <ConfirmationDialog ref="confirmationRef" :confirmationButtonText="confirmationButtonText"></ConfirmationDialog>
          <UnosOIBa ref="unosOibaRef" :povratnaFunkcija="getUslugeZaOdjavu"></UnosOIBa>
        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import { mapState, mapGetters } from 'vuex';
  import ProgressBar from '../Common/Components/MyToolbarProgressBar.vue';
  import ConfirmationDialog from '../Common/Components/ConfirmationDialog.vue';
  import ExamTr from './exam_unregister_components/ExamTR.vue';
  import UnosOIBa from './exam_common/UnosOIBa.vue'

  export default {
    name: 'ExamUnregister',
    mounted() {
      this.getUslugeZaOdjavu();

      if (!this.currentUser.OIB || this.currentUser.OIB.length != 11) {
        this.$refs.unosOibaRef.show();
      }
    },

    data: () => ({
      tableData: [],
      pagination: {
        rowsPerPage: 100
      },
      loadingData: false,
      odjavljujemIspit: false
    }),

    computed: {
      ...mapState('app', ['currentUser']),
      ...mapGetters('app', { getTitleColorStore: 'getTitleColor' }),

      confirmationButtonText() {
        return this.$t('exam_unregister.confirm_button');
      },

      loading() {
        return this.loadingData || this.odjavljujemIspit;
      },

      userImaOIB() {
        if (this.currentUser.OIB && this.currentUser.OIB.length == 11) {
          return true;
        } else {
          return false;
        }
      },

    },

    methods: {
      passEvent(e) {


        var callback = (isOk) => {
          this.odjavljujemIspit = true;

          if (isOk) {
            var data = { PredbiljezbaId: e.item.OsobaPredbiljezbe_ID };
            this.$fetchDataPromise('/api/Exam/OdjaviIspit', data)
              .then(x => {
                this.tableData = this.tableData.filter(x => x.OsobaPredbiljezbe_ID != e.item.OsobaPredbiljezbe_ID);
                this.$displaySuccess(this.$t('server_msg.exam_unregister.exam_cancelled'))
              })
              .catch(x => { this.$displayError(x); })
              .then(x => this.odjavljujemIspit = false);
          } else {
            this.odjavljujemIspit = false
          }

        }

        var datumFormatted = moment(e.item.Datum).format('DD.MM.YYYY');
        var vrijemeFormatted = moment(e.item.TerminOd).format('HH:mm');
        var pitanje = this.$t('exam_unregister.confirm_cancelation', { name: e.item.Ime, date_time: datumFormatted + ' ' + vrijemeFormatted });
        this.$refs.confirmationRef.showDialog(callback, pitanje);


      },

      async getUslugeZaOdjavu() {
        this.loadingData = true;

        var uslugeZaOdjavu = await this.$fetchDataPromise('/api/Exam/GetUslugeZaOdjavuIspita', null).catch(x => { this.loadingData = false; this.$displayError(x); });

        this.tableData = uslugeZaOdjavu;
        this.loadingData = false;
      },

      headers1() {
        return [
          {
            sortable: false,
            text: this.$t('exam_unregister.terms_table_headers.term_date'),
            value: 'center'
          },
          {
            sortable: false,
            text: this.$t('exam_unregister.terms_table_headers.term_time'),
            value: 'Vrijeme',
            align: 'center'
          },
          {
            sortable: false,
            text: this.$t('exam_unregister.terms_table_headers.education_name'),
            value: 'Ucionica',
            align: 'left'
          },
          {
            sortable: false,
            text: this.$t('exam_unregister.terms_table_headers.address'),
            value: 'Ucionica',
            align: 'left'
          },
          {
            sortable: false,
            text: this.$t('exam_unregister.terms_table_headers.classroom'),
            value: 'Adresa',
            align: 'left'
          },
          {
            sortable: false,
            text: '',
            value: 'Button',
            align: 'center'
          },

        ]
      }
    },

    components: {
      ProgressBar, ConfirmationDialog, ExamTr, UnosOIBa
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Exams/ExamUnregister.vue